/**
 * APIs 接口集合
 * @Description:用于存储全站所有接口（包含可能出现的站外接口、图片验证码生成、短信验证码等接口）
 *
 * @Author: JZT.Oscar
 * @Date: 2018-09-26 11:40:53
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2019-04-12 17:11:48
 */
// 公共接口
const COMMON = {
    OCR_DISCRIMINATE: "/api/app/ocr/getLicenceResultNew",
    // 图片上传
    COMMON_UPLOAD: "/api/sys/common/uploadImg",
    // 获取站点列表，不根据权限筛选（已经毁了，实际接口中的sql已经同站点管理列表查询一样了）
    GET_ALL_SITES: "/api/site/getSiteList.json",
    // 不同于站点管理中的部分区域disabled了，这里是完整的区域数
    GET_ALL_AREA_TREE: "/api/common/getAllArea",
    // 下拉查询站点接口
    SEARCH_NEW_SITE_LIST: "/api/common/getSiteInfo",
    // 获取用户消息通知信息
    GET_NOTIFY: "/api/message/getUserMessageInfo.json",
    // 读取消息
    UPDATE_MESSSAGE_INFO: "/api/message/updateMessageStatus.json",
    // 批量读取消息
    UPDATE_BATCH_MESSAGE_INFO: "/api/message/updateBatchMessageStatus.json",
    // 登录状态和用户认证信息
    LOGIN_INFO: '/user/loginStatus.json',
    // 绑定账号列表
    BIND_ACCOUNT_LIST: '/user/bindAccountList',
    // 修改密码
    RESET_PASSWORD: '/api/sys/sysUser/editPwd',
    // 切换账号
    EXCHANGE_ACCOUNT: '/user/bindAccountLogin',
    // 快速获取资质证照
    GET_DZSY_LICENCE: '/api/dzsy/getLicence',
    // 店铺上下线
    SET_STORE_ONLINE: '/api/admin/store/updateOnline',
};

// 站点管理
const SITE_MGR = {
    // 查询站点列表(联调完成)
    SEARCH_SITE_LIST: "/api/site/list.json",
    // 导出站点列表(联调完成)
    EXPORT_SITE_LIST: "/api/site/exportExcel.json",
    // 站点状态：启用/禁用(联调完成)
    TOGGLE_SITE_STATE: "/api/site/updateStatus.json",
    // 批量删除站点(联调完成)
    BATCH_REMOVE_SITES: "/api/site/delete.json",

    // 获取区域完整树结构(联调完成)
    GET_FULLAREA_TREE: "/api/common/getArea.json",
    // 获取已配置经营区域(待肖俊修改完成)
    GET_SELECTED_AREA: "/api/site/getSiteArea.json",
    // 保存区域配置(保存报错)
    SAVE_SITE_AREA: "/api/site/areaConfig.json",

    // 新增一条站点(联调完成)
    ADD_SITE_INFO: "/api/site/add.json",
    // 保存基础配置(联调完成)
    SAVE_SITE_BASE_INFO: "/api/site/baseConfig.json",

    // 获取支付信息(联调完成)
    GET_SITE_PAY_INFO: "/api/site/getSitePayConfig.json",
    // 文件上传(联调完成)
    GLOBAL_UPLOAD_FILES: "/api/site/uploadCertificate",
    // 获取站点支持的银行列表(联调完成)
    GET_SITE_SUPPORT_BANKS: "/api/common/getBankList",
    // 保存支付配置(联调完成)
    SAVE_SITE_PAY_INFO: "/api/site/payConfig.json",
    // 获取省市数据(联调完成)
    GET_PROV_CITY_DATA: "/api/common/getProvCityData.json",
    // 获取支付管理配置
    GET_ONLINE_TYPE: "/api/config/getOnlineType",
    // 保存超管支付配置
    SAVE_PAYCONFIG: "/api/super/payConfig"
};

// 商品管理
const GOODS_MGR = {
    // 获取经营简码
    GET_BUSICODE_TREE: "/api/prodscopenoList",
    // 查询证照关系列表
    SEARCH_LICENSE_LIST: "/api/admin/licence/getLicence",
    // 获取单条证照关系详情
    GET_LICENSE_DETAIL: "/api/admin/licence/getLicenceDetail",
    // 删除证照关系
    DELETE_LICENSE: "/api/admin/licence/delete",
    // 查询证照类型
    SEARCH_LICENSE_TYPE: "/api/licence/getLicenceType",
    // 查询客户类型
    SEARCH_DICT: "/api/dict/getCustDict",
    // 新增或修改一条证照关系
    SAVE_LICENSE: "/api/admin/licence/save",
    // 查询我的商品列表
    SEARCH_GOODS_LIST: "/api/goodsmanager/goodsList",
    // 关联厂家和分销商商品
    RELATION_MANUFACTURE_BRANCH:
        "/api/goodsmanager/insertManufactureBranchRelation",
    // 校验商品是否能上架
    CHECK_GOODS_UP: "/api/goodsmanager/goodsup/check",
    // 商品上架
    PUT_GOODS_UP: "/api/goodsmanager/goods/up",
    // 商品编辑
    PUT_GOODS_EDIT: "/api/goodsmanager/goods/edit",
    // 修改底价
    UPDATE_FLOOR_PRICE: "/api/goodsmanager/updateBottomPrice",
    // 修改销售平台
    UPDATE_PLATFORM: "/api/goodsmanager/updateSalePlatform",
    // 商品下架
    PUT_GOODS_DOWN: "/api/goodsmanager/goods/down",
    // 复制商品
    COPY_GOODS: "/api/goodsmanager/goods/copy",
    // 修改价格
    UPDATE_PRICE: "/api/goodsmanager/updatePrice",
    // 修改库存
    UPDATE_STORAGE: "/api/goodsmanager/updateStorage",
    // 批量上架
    BATCH_UP: "/api/goodsmanager/goods/batchUp",
    // 批量下架
    BATCH_DOWN: "/api/goodsmanager/goods/batchDown",
    // 可批量申请售卖个数
    SALES_APPLY_NUM: "/api/sales_apply/stats",
    // 商品详情
    GET_GOODS_DETAIL: "/api/goods/getGoodsDetail",
    // 导出商品列表
    EXPORT_GOODS_LIST: "/api/goodsmanager/upgradeExportExcel",
    // 导出售卖申请商品列表
    EXPORT_SALE_GOODS_LIST: "/api/goodsmanager/downloadExcel",
    // 查看证照
    CHeck_PHOTO: "/api/qualificationApply/getLicenceList",
    // 商品资质审核
    GOODS_AUDIT: "/api/qualificationApply/audit",
    // 商品资质批量通过
    GOODS_BATCH_AUDIT: "/api/qualificationApply/batchAuditPass",
    // 获取商品标品列表
    GET_GOODS_LIST: "/api/goods/getGoodsList",
    // 获取经营范围树和存储分类
    GET_SALEAPPLY_DATA: "/api/goods/getSaleApplyData",
    // 商品资料申请查询
    SEARCH_GOODS_APPLY: "/api/qualificationApply/getAuditList",
    // 删除商品记录
    DEL_GOODS_NOTE: "/api/qualificationApply/deleteApply",
    // 商品维护查询
    GOODS_SALE_CARE: "/api/goodsmanager/getGoodsListInfo",
    // 商品维护状态更新
    GOODS_CARE_STATUS: "/api/goodsmanager/updateGoodsAttribute",
    // 获取申请修改数据
    GET_EDIT_APPLY: "/api/qualificationApply/getEditApply",
    // 平台商品属性维护excel
    GET_GOODS_CARE_EX: "/api/goodsmanager/downloadGoodsListExcel",
    // 我的商品库修改资质回显
    GET_MERCHANDISE_QULIFICATION:
        "/api/goodsmanager/getMerchandiseQulification",
    UPDATE_ERP_INVOICE: "/api/goodsmanager/goods/updateErpInvoice",
    // 我的商品库提交修改
    APPLY_MERCHANDISE_QULIFICATION:
        "/api/goodsmanager/applyMerchandiseQulification",
    // 商品资料申请记录查询
    SEARCH_GOODS_APPLY_NOTE: "/api/qualificationApply/getApplyList",
    // 商品分类和处方分类
    GET_GOODS_CLASS: "/api/goods/getAddGoodsApplyData",
    // 根据站点id和经营简码获取必传证照列表
    GETLECENCE_LISTBYSITE_AND_PRODSCOPENO:
        "/api/goods/getLicenceListBySiteAndProdscopeno",
    // 获取申请修改数据
    GET_CHANGE_DATA: "/api/qualificationApply/getEditType",
    // 商品审核进度查询
    GET_GOODS_REVIEW: "/api/qualificationApply/getAuditProgress",
    // 提交售卖商品资质申请
    SUBMIT_QUALIFICATION_APPLY: "/api/goods/submitQualificationApply",
    // 说明书图片识别文字
    RECGN_SPECIFICATION: "/api/goodsmanager/characterRecognition",
    // 说明书文字分段
    SPLIT_SPECIFICATION: "/api/goodsmanager/confirmToSubmit",
    // 获取通用名及生产厂家检索
    SEARCH_LOCAL_NAME: "/api/goods/retrievalInfo",
    // 检索商品品牌接口
    SEARCH_BRAND: "/api/goods/selectBrand",
    // 获取税务名称树
    GET_TAX_TREE: "/api/basicTax/getTree",
    // 提交新增商品
    ADD_NEW_GOODS: "/api/goods/submitAddApply",
    // 校验商品是否存在接口
    CHECK_GOODS_EXIST: "/api/goods/validateGoodsIsExist",
    // 商品示意图地址
    EXAMPLE_PIC: "/api/goodsmanager/pictureuri",
    // 商品中心图片上传
    PRODCENTER_UPLOAD: "/api/prodCenter/uploadImg",
    // 获取商品图片
    GET_PRO_PICS: "/api/merchandise/getpicture",
    // 重置图片按钮
    GET_GOODS_PICTURE: "/api/merchandise/getgoodspicture",
    // 修改店铺商品图片
    UPDATE_PICTURE: "/api/merchandise/updatepicture",
    // 商品库上传图片
    UPLOAD_MERCHANDISE_IMG: "/api/sys/store/uploadMerchandiseImg",
    // 添加限购策略
    ADD_LIMIT_SALE: "/api/limitSale/add",
    // 查询限购策略列表
    GET_LIMIT_SALE_LIST: "/api/limitSale/getAll",
    // 查询限购策略详情
    GET_LIMIT_SALE_DETAIL: "/api/limitSale/detail",
    // 修改策状态
    UPDATE_LIMIT_SALE_STATUS: "/api/limitSale/updateStatus",
    // 获取货主库存
    GET_OWNER_STORAGE_BY_PROD: "/api/goodsmanager/getMerchandiseOwnerInfosByStoreProdNo.json",
    // 商业公司选择
    GET_BRANCH_LIST: '/api/limitsale/selectBranchInfoList'
};

// 角色管理
const SYS_ROLE = {
    // 查询角色列表
    SEARCH_SYS_ROLE: "/api/sys/sysRole/getDatatList",
    // 删除角色
    DELETE_SYS_ROLE: "/api/sys/sysRole/delete",
    // 新增角色
    ADD_SYS_ROLE: "/api/sys/sysRole/add",
    // 编辑角色
    EDIT_SYS_ROLE: "/api/sys/sysRole/edit",
    // 查看角色
    CHECK_SYS_ROLE: "/api/sys/sysRole/getRoleById",
    // 获取角色菜单
    GET_ROLE_TREE: "/api/sys/sysRole/getMenuTree",
    // 导出角色列表
    EXPORT_ROLE_LIST: "/api/sys/sysRole/export",
    // 获取角色菜单id拼接成的字符串
    GET_ROLE_MENUSTR: "/api/sys/sysRole/getRoleMenuStr",
    // 根据角色类型获取消息通知菜单
    GET_NOTIFY_LIST: "/api/sys/sysRole/getNotifyTreeByRoleType",
    // 获取角色已选择的消息通知列表
    GET_NOTIFYSTR: "/api/sys/sysRole/getRoleNotifyStr"
};

// 账号管理
const ACCOUNT_MGR = {
    // 查询账号列表
    SEARCH_SYS_ACCOUNT: "/api/sys/sysUser/getData",
    // 删除账号
    DELETE_SYS_ACCOUNT: "/api/sys/sysUser/deleteUser",
    // 更改账号状态
    TOGGLE_ACCOUNT_STATE: "/api/sys/sysUser/updateStatus",
    // 创建账号
    CREATE_SYS_ACCOUNT: "/api/sys/sysUser/createUser",
    // 未分配站点管理员的站点
    SEARCH_UNALLOCATED_SITE: "/api/sys/sysUser/unAllOcatedSites",
    // 编辑账号
    EDIT_SYS_ACCOUNT: "/api/sys/sysUser/editUser",
    // 导出账号列表
    EXPORT_SYSUSER_LIST: "/api/sys/sysUser/exportExcel",
    // 重置密码
    UPDATE_SYSUSER_PWD: "/api/sys/sysUser/updatePwd",
    // 账号原有角色信息
    GET_SYSUSER_ROLE: "/api/sys/sysUser/role",
    // 选择角色
    ACCOUNT_GET_SYSUSER_ROLE: "/api/sys/sysRole/getUserRole"
};

// 菜单管理
const MENU_MGR = {
    // 查询菜单管理列表
    SEARCH_MENU_LIST: "/api/sys_menu/query",
    // 查询菜单管理列表
    UPDATE_MENU_LIST: "/api/sys_menu/updateSort",
    // 导出菜单列表
    EXPORT_MENU_LIST: "/api/sys_menu/excel",
    // 获取用户菜单树
    GET_USER_MENU: "/api/sys_menu/getUserMenuTree",
    // 获取当前登录用户信息
    GET_USER_AGENT: "/api/userAgent/getCurrentUser"
};

// 店铺菜单管理
const SHOP_MENU_MGR = {
    // 查询店铺菜单管理列表
    SEARCH_SHOPMENU_LIST: "/api/storeRole/getStoreRoleList.json",
    // 编辑店铺菜单
    EDIT_SHOPMENU_LIST: "/api/storeRole/editStoreRole.json",
    // 编辑前查看店铺菜单 & 店铺菜单树
    VIEW_SHOPMENU_TREE: "/api/storeRole/getStoreRole.json",
    // 批量编辑店铺菜单
    BATCH_EDITSTORE_ROLE: "/api/storeRole/batchEditStoreRole.json",
    // 批量编辑店铺菜单时异步显示菜单名称
    GET_STORE_MENUNAME: "/api/storeRole/getStoreMenuName.json",
    // 查看店铺菜单
    GET_EXIS_STORE_ROLE: "/api/storeRole/getExisStoreRole.json",
    // 导出店铺菜单列表
    EXPORT_SHOPMENU_LIST: "/api/storeRole/excelStoreRoleList.json"
};

// 系统公告
const SYS_NOTICE = {
    // 分页查询：筛选公告列表(联调完成)
    SEARCH_NOTICE_LIST: "/api/sys/sysNotice/getDataList",
    // 删除：批量删除(联调完成)
    BATCH_REMOVE_NOTICES: "/api/sys/sysNotice/delete",
    // 导出：导出 Excel(联调完成)
    EXPORT_NOTICES_LIST: "/api/sys/sysNotice/export",
    // 添加：添加一条公告(联调完成)
    ADD_NOTICE_INFO: "/api/sys/sysNotice/add",
    // 查询：查询指定公告信息(联调完成)
    GET_NOTICE_INFO: "/api/sys/sysNotice/getNoticeById",
    // 保存：保存公告信息(联调完成)
    SAVE_NOTICE_INFO: "/api/sys/sysNotice/edit",
    // 置顶/取消置顶(联调完成)
    TOGGLE_NOTICE_STATE: "/api/sys/sysNotice/toTop"
};

// 客户管理
const CUST_MGR = {
    // 客户资质审核
    CUST_CHECK_CUST: "/api/sys/sysCust/checkCust",
    // 导出EXCEL
    CUST_EXPORT_EXECL: "/api/sys/sysCust/exportCustList",
    // 查询客户列表
    GET_CUST_DATA: "/api/sys/sysCust/getData",
    // 禁用启用客户
    CUST_UPDATE_STATUS: "/api/sys/sysCust/updateStatus",
    // 获取审核资质信息
    GET_APPLY_MESSAGE: "/api/sys/sysCust/getApplyMessage",
    // 获取客户详情信息
    GET_CUST_MESSAGE: "/api/custMain/getDetailCustInfo",
    // 获取更新审核信息
    GET_CHANGE_MESSAGE: "/api/sys/sysCust/getApplyChangeMessage",
    // 转发站点
    CUST_FOWARD_STATION: "/api/sys/sysCust/fowardStation",
    // 建采关系列表查询
    SEARCH_RELATION_LIST: "/api/cust/relation/getDataList",
    // 建采启用禁用
    GET_ENABLE_DISABLE: "/api/cust/relation/changeCustStatus",
    // 建采关系导出
    GET_EXPORT_RELATION: "/api/cust/relation/newExport",
    // 解除建采
    UPDATE_DISABLE_RELATION: "/api/cust/relation/disable",
    // 开启&关闭公对公打款
    PUBLIC_PAYMENT_STATUS: "/api/cust/relation/publicPaymentStatus",
    // 获取列表统计
    GET_RELATION_DATACOUNT: "/api/cust/relation/dataCount",
    // 建采关系审核
    GET_RELATION_AUDIT: "/api/cust/relation/audit",
    // 建采关系更新资质信息
    GET_UPDATE_CUSTRELATION: "/api/sys/sysCust/getCustRelationChangeMessage",
    // 修改客户的编码
    UPDATE_RELATION_CUSTNO: "/api/cust/updateStoreCustNo",
    // 导出 导入的客户列表错误信息
    EXPORT_CUST_ERROR_DATA: "/api/sys/sysCust/exportCustErrorData",
    // ERP商业公司下拉列表
    ERP_STORE_LIST: "/api/sys/erpStore/list",
    // ERP客户列表
    ERP_CUST_LIST: "/api/sys/erpCust/getData",
    // ERP客户导出
    EXPORT_CUST_LIST: "/api/sys/erpCust/export"
};

// 订单管理
const ORDER_MGR = {
    // 订单列表接口
    GET_ORDER_LIST: "/api/ordermanager/orderList",
    // 订单详情
    GET_ORDER_INFO: "/api/ordermanager/order/info",
    // 订单详情-货位列表
    GET_ORDER_STORE_OWNER_LIST: "/api/ordermanager/order/getStoreOwnerInfoList",
    // 订单审核
    GET_ORDER_AUDIT: "/api/ordermanager/order/audit",
    // 订单拒收
    GET_ORDER_REJECT: "/api/ordermanager/order/reject",
    // 订单出库
    GET_ORDER_STOCKOUT: "/api/ordermanager/stockout",
    // 批量导出订单详情
    GET_ORDER_DOWNLOAD: "/api/ordermanager/order/downloadExcel",
    // 批量导出订单列表
    EXPORT_ORDER_LIST: "/api/ordermanager/exportOrderList",
    // 电子发票上传
    UPLOAD_ELECTRONIC_INVOICE: "/api/upload/electronicinvoice",
    // 取消订单
    POST_ORDER_cancel: "/api/ordermanager/order/cancel",
    // 根据adcode查询区域
    GET_AREA_INFO: "/api/areamanager/areainfo",
    // 订单部分出库
    POST_ORDER_STOCKOUT: "/api/ordermanager/someGoodsStockOut",
    // 不出库商品
    CANCEL_ORDER_STOCKOUT: "/api/ordermanager/cancelStocked",
    // 拒收
    REFUND_SOME_PACKAGE: "/api/ordermanager/refundSomePackage",
    // 开户
    OPEN_ACCOUNT: "/api/ordermanager/confirmOpenAccount",
    // 下载企业资质
    GET_QUALIFICATION_DOWNLOAD: "/api/custMain/downloadCompanyLicence",
    // 获取特殊订单提示信息和是否开启了erp订单同步的开关
    GET_SPECIAL_ORDER_INFO: "/api/order/getOrderTipsInfo",
    // 更新订单详情中商品erpno
    UPDATE_ORDER_ERPNO: "/api/ordermanager/order/updateErpNo",
    // 更新订单店铺客户编码
    UPDATE_ORDER_CUSTNO: "/api/ordermanager/order/updateStoreCustNo",
    // 获取退款申请信息
    ADD_REFUND_APPLY: "/api/refund/addRefundApply",
    // 退款申请查看
    GET_REFUNDAPPLY_INFO: "/api/refund/getRefundApplyInfo",
    // 退款申请保存
    SAVE_REFUND_APPLY: "/api/refund/saveRefundApply",
    // 退款申请审核列表
    GET_REFUNDAPPLY_LIST: "/api/refund/getRefundApplyList",
    // 退款申请列表导出
    EXPORT_REFUND_APPLY: "/api/refund/exportRefundApplyList",
    // 退款审核-通过或驳回
    REFUND_AUDITBATCH_REFUSE: "/api/refund/refundAuditBatchRefuse",
    // 退款审核-通过或驳回
    REFUND_AUDIT_PASS: "/api/refund/refundAuditPass",
    // 判断是否可以申请退款
    CHECK_REFUND: "/api/refund/checkRefund",
    // 订单提现列表
    GET_ORDER_RLIST: "/api/orderWithdraw/getOrderList",
    // 订单提现审核列表
    GET_ORDERWITHDRAW_LIST: "/api/orderWithdraw/getOrderWithdrawList",
    // 店铺订单提现详情列表
    GET_ORDERWITHDRAW_DETAILLIST:
        "/api/orderWithdraw/getOrderWithdrawDetailList",
    // 提现审核列表导出(提现审核)
    WITHDRAW_EXPORT_ADMIN: "/api/orderWithdraw/orderWithdrawListExportAdmin",
    // 提现详情列表导出(提现审核)
    WITHDRAW_DETAIL_EXPORT_ADMIN:
        "/api/orderWithdraw/orderWithdrawDetailListExportAdmin",
    // 提现审核列表导出(提现记录)
    WITHDRAW_LIST_EXPORT: "/api/orderWithdraw/orderWithdrawListExport",
    // 提现详情列表导出(提现记录)
    WITHDRAW_DETAIL_EXPORT: "/api/orderWithdraw/orderWithdrawDetailListExport",
    // 订单交易流水导出
    PAYMENT_RECORD_EXPORT: "/api/orderWithdraw/paymentRecordListExport",
    // 订单提现审核、打款
    ORDER_WITHDRAW_AUDIT: "/api/orderWithdraw/audit",
    // 更新包裹主表
    UPDATE_PACKAGE_MAIN: "/api/order/update_package_main",
    // 提现列表导出
    ORDER_LIST_EXPORT: "/api/orderWithdraw/orderListExport",
    // 获取物流信息
    GET_LOGISTICS: "/api/ordermanager/order/getlogistics",
    // 控销团队下拉选项
    GET_ALL_SUPPLIER: "/api/ordermanager/getAllSupplier"
};

// 富文本编辑器
const UEDITORS = {
    // 上传图片
    UEDITOR_UPLOAD_API: "/api/ueditor/config"
};

// 店铺管理
const SHOP_MGR = {
    // 保存经营简码
    PRODSCOPE_SAVE: "/api/prodscope/save",
    // 查询店铺列表
    SEARCH_SHOP_LIST: "/api/admin/store/getStore",
    // 查看店铺认证信息
    GET_SHOP_AUTHINFO: "/api/admin/store/getAuthInfo",
    // 查看店铺更新认证信息
    GET_SHOP_MODIFY_INFO: "/api/admin/store/getModifyAuthInfo",
    // 配置店铺首页
    GET_PALTFORM_LIST: "/api/admin/store/getPaltFormList",
    // 配置店铺商品
    GET_SHOP_PRODUCT: "/api/admin/store/getProdList",
    // 保存店铺商品
    SAVE_SHOP_PRODUCT: "/api/admin/store/saveBasicInfo",
    // 修改店铺首页信息
    UPDATE_SHOP_HOME: "/api/admin/store/saveIndexInfo",
    // 切换店铺启用/禁用状态
    TOGGLE_SHOP_STATE: "/api/admin/store/limit",
    // 获取店铺商户号配置
    GET_SHOPNUM: "/api/admin/store/shopNum",
    // 保存店铺商户号配置
    SAVE_SHOPNUM: "/api/store/saveShopNum",
    // 店铺首页信息保存
    EDIT_FLOOR_ORDER: "/api/admin/store/editFloorOrder",

    // 获取店铺首页楼层信息
    GET_GOODSFLOOR_DETAIL: "/api/admin/store/getGoodsFloorDetail",
    // 保存店铺首页楼层修改
    SAVE_GOODS_FLOOR: "/api/admin/store/saveGoodsFloor",
    // 店铺首页楼层删除
    DELETE_PAGELIST_MODULE: "/api/admin/store/deletePageListModule",
    // 审核店铺认证信息
    CHECK_SHOP_INFO: "/api/admin/store/checkStore",
    // 撤回店铺认证更新信息
    ROLLBACK_SHOP_UPDATE_INFO: "/api/admin/store/reback",
    // 导出店铺excel
    EXPORT_SHOP_LIST: "/api/admin/store/getStoreExcel",
    // 店铺转发
    TRANSMIT_SHOP: "/api/admin/store/transmit",
    // 店铺基础信息查询
    GET_SHOP_INFO: "/api/admin/store/getBasicInfo",
    // 店铺基础信息配置
    CONFIG_SHOP_INFO: "/api/admin/store/saveBasicInfo",
    // 通过经营范围返回证照信息
    GET_SCOPE_LICENCE: "/api/admin/store/getProdscopenosLicences",
    // 店铺更新认证信息
    UPDATE_SHOP_AUTH: "/api/admin/store/updateStoreAuth",
    // 开店
    OPEN_STORE: "/api/admin/store/openStore",
    // 添加商品
    ADD_PROD: "/api/admin/store/addIndexInfoProd",
    // 删除商品
    DEL_PROD: "/api/admin/store/deleteIndexInfoProd",
    // 店铺商品查询
    CHECH_STORE_PROD: "/api/admin/store/getIndexInfoProdList",
    // 获取ERP同步配置
    GET_STORE_ERPSYNC: "/api/store/ds/select",
    // 修改ERP同步配置
    UPDATE_STORE_ERPSYNC: "/api/store/ds/update",
    // 未配置商户号店铺全局弹窗
    OVERALL_SHOPNUM: "/api/warning/shopNum",
    // 获取收款账户配置信息
    GET_RECEIVABLEVO: "/api/store/getReceivableVo",
    // 保存收款账户配置信息
    SAVE_RECEIVABLEVO: "/api/store/saveReceivableVo",
    // 获取店铺发票配置信息
    GET_STORE_INVOICE: "/api/store/getStoreInvoice",
    // 保存店铺发票配置信息
    SAVE_STORE_INVOICE: "/api/store/saveStoreInvoice",
    // 提成配置列表查询
    GET_COMMISSION_CONFIG_LIST: "/api/store/getStoreIntegralInfo",
    // 获取店铺药品信息
    GET_STORE_MERCHANDISE_LIST: "/api/store/getStoreMerchandiseInfo", // 废弃
    // 保存店铺及特殊药品提成比例
    SAVE_STORE_RATE: "/api/store/saveStoreIntegralInfo",
    // 积分比例导入模板下载
    RATE_EXCEL_TEMP:
        "https://files-wyc.obs.cn-east-3.myhuaweicloud.com/upload/file/%E7%A7%AF%E5%88%86%E6%AF%94%E4%BE%8B%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx",
    // 积分金额导入模板下载
    POINT_EXCEL_TEMP:
        "https://files-wyc.obs.cn-east-3.myhuaweicloud.com/upload/file/%E7%A7%AF%E5%88%86%E9%87%91%E9%A2%9D%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xlsx",
    // 店铺积分excel导入
    MERCHANDISE_POINT_IMPORT: "/api/store/merchandise-integral-import"
};

// 资金管理
const PAYMENT_CENTER = {
    // 查询交易记录
    SEARCH_TRADE_LIST: "/api/admin/payCenter/list.json",
    // 导出交易记录excel
    EXPORT_TRADE_LIST: "/api/admin/payCenter/exportList.json",
    // 店铺提现交易记录查询
    SEARCH_WITHDRAW_TRADE_LIST: "/api/ordermanager/getTradeOrderPageList",
    // 店铺提现资金汇总查询
    GET_WITHDRAW_TRADE_SUM: "/api/ordermanager/getStoreFundInfo",
    // 店铺提现交易记录导出
    EXPORT_WITHDRAW_TRADE: "/api/ordermanager/tradeOrderExport",
    // 提现
    WITHDRAW_ORDER: "/api/ordermanager/orderWithdraw",
    // 重试提现
    RE_WITHDRAW_ORDER: "/api/orderWithdraw/retryOrderWithdraw",
    // 账户总览汇总查询
    GET_ACCOUNT_OVERVIEW_SUM: "/api/accountOverview/groupQuery",
    // 账户总览收支明细查询
    SEARCH_ACCOUNT_OVERVIEW_LIST: "/api/accountOverview/paymentDetails",
    // 账户总览收支明细导出
    EXPORT_ACCOUNT_OVERVIEW: "/api/exportPaymentDetails",
    // 提现申请保存
    SAVE_ORDER_WITHDRAW: "/api/orderWithdraw/saveOrderWithdraw",
    // 订单提现查询可提现金额、待结算金额、冻结金额
    GET_TOTAL_AMOUNT: "/api/orderWithdraw/getTotalAmount",
    // 中金影印件采集
    IMAGE_ACQUISITION: "/api/admin/storePayment/tx4600",
    // 中金开户
    ACCOUNT_OPEN: "/api/admin/storePayment/tx4601",
    // 中金签约
    SIGNING_APPLY: "/api/admin/storePayment/tx7703",
    // 查询中金支付详情
    GET_PAYMENT_INFO: "/api/admin/storePayment/getStoreInfo"
};

// 秒杀
const SECOND_KILL = {
    SEARCH_SECKILL_LIST: "/api/seckill/getSeckillList", // 秒杀场次列表
    GET_SECKILL_DETAIL: "/api/seckill/getSeckillDetail", // 秒杀场次详情
    SAVE_SECKILL: "/api/seckill/addOrUpdateSeckill", // 新增/修改秒杀场次
    SEARCH_SHOW_PROD_LIST: "/api/seckill/getShowMerchandiseList", // 查询符合场次的商品
    FINISH_SECKILL: "/api/seckill/finishSeckill", // 提前结束秒杀
    DELETE_SECKILL: "/api/seckill/deleteSeckill", // 删除秒杀

    SEARCH_SECKILL_ACT_LIST: "/api/seckillactivity/list", // 秒杀活动列表
    GET_SECKILL_ACT_DETAIL: "/api/seckillactivity/detail", // 秒杀活动详情
    SAVE_SECKILL_ACT: "/api/seckillactivity/addOrUpdate", // 新增/修改秒杀活动
    SEARCH_SECKILL_ACT_PROD_LIST: "/api/seckillactivity/storeMerchandiseList", // 秒杀活动商品列表
    FINISH_SECKILL_ACT: "/api/seckillactivity/finish", // 提前结束秒杀活动
    DELETE_SECKILL_ACT: "/api/seckillactivity/delete", // 删除秒杀活动
    TOGGLE_SECKILL_ACT: "/api/seckillactivity/enableOrDisable" // 启用/暂停秒杀活动
};

//  管控
const AGREED_AREAS = {
    //  查询管控列表
    SEARCH_AGREED_AREAS: "/api/limitsale/selectLimitSaleGoodsList",
    // 导出管控excel
    EXPORT_LIMITSALE_LIST: "/api/limitsale/exportExcelLimitSale",
    // 批量删除
    DELETE_LIMITSALE: "/api/limitsale/deleteLimitSale",
    // 根据店铺获取商品信息
    SELECT_GOODS_LIST: "/api/goods/selectGoodsInfoList",
    // 获取和店铺建采的客户列表
    SELECT_CUSTOMER_LIST: "/api/goods/selectCustMianInfo",
    // 获取客户类型
    GET_CUSTOMER_TYPE: "/api/dict/selectCustTypeDict",
    // 获取区域
    GET_ALL_AREA: "/api/common/getAllArea",
    // 编辑管控
    EDIT_LIMITSALE_ITEM: "/api/limitsale/selectLimitInfoByStoreProdNo",
    // 保存管控规则接口
    SAVE_LIMITSALE_LIST: "/api/limitsale/saveLimitSale",
    // 店铺检索
    GET_STORE_LIST: "/api/goods/selectStoreNameList",
    GET_SUPPLIER: "/api/goods/selectRelationStoreNameList",
    GET_IMPORT_PROCESS: "/api/sys/sysCust/batchImportProgress"
};

// 标签
const LABLE = {
    // 查询标签
    LABLE_PAGE_QUERY: "/api/label/query",
    // 选择标签
    LABLE_PAGE_SELECT_QUERY: "/api/label/select_query",
    // 标签名称是否存在
    LABLE_EXISTS_LABEL_NAME: "/api/label/existsLabelName",
    // 新增标签
    LABLE_ADD: "/api/label/insert",
    // 更新标签
    LABLE_UPDATE: "/api/label/update",
    // 根据ID查询
    LABLE_GET: "/api/label/get",
    // 标签客户查询
    LABLE_QUERY_CUST_LIST: "/api/label/queryCustList",
    // 标签商品查询(店铺)
    LABLE_QUERY_MERCHANDISE_LIST: "/api/label/queryMerchandiseList",
    // 批量删除标签
    LABLE_DELETE_LABEL_BATCH: "/api/label/deleteLabelBatch",
    // 批量打标-客户
    LABLE_MARK_CUST: "/api/label/markCust",
    // 批量打标-店铺商品
    LABLE_MARK_MERCHANDISE: "/api/label/markMerchandise",
    // 批量删标-客户的标签
    LABLE_DELETE_CUST: "/api/label/deleteCust",
    // 批量删标-产品的标签
    LABLE_DELETE_MERCHANDISE: "/api/label/deleteMerchandise",
    // 选择客户
    LABLE_PAGE_SELECT_CUST_MIAN_INFO: "/api/label/goods/selectCustMianInfo",
    // 选择商品单位
    LABLE_PAGE_SELECT_GOODS_INFO_LIST: "/api/label/goods/selectGoodsInfoList",
    // 选择产品单位
    LABLE_PAGE_SELECT_GOODS_INFO_LIST2: "/api/label/goods/selectGoodsInfoList2",
    // 选择商品单位
    LABLE_PAGE_SELECT_GOODS: "/api/label/goods/selectGoods"
};

// 满减活动
const ACTIVITY_REBATE = {
    // 查询满减
    ACTIVITY_REBATE_QUERY: "/api/activity/rebate/query",
    // 新增满减活动
    ACTIVITY_REBATE_INSERT: "/api/activity/rebate/insert",
    // 获取满减
    ACTIVITY_REBATE_GET: "/api/activity/rebate/get",
    // 更新满减活动
    ACTIVITY_REBATE_UPDATE: "/api/activity/rebate/update",
    // 暂停活动
    ACTIVITY_REBATE_PAUSE: "/api/activity/rebate/pause",
    // 启用活动
    ACTIVITY_REBATE_ACTIVE: "/api/activity/rebate/active",
    // 删除活动
    ACTIVITY_REBATE_DELETE: "/api/activity/rebate/delete",
    // 提前结束活动
    ACTIVITY_REBATE_TERMINAL: "/api/activity/rebate/terminal"
};

// 优惠券活动
const ACTIVITY_COUPON = {
    // 查询优惠券
    ACTIVITY_COUPON_QUERY: "/api/activity/coupon/query",
    // 新增优惠劵
    ACTIVITY_COUPON_INSERT: "/api/activity/coupon/insert",
    // 更新优惠劵
    ACTIVITY_COUPON_UPDATE: "/api/activity/coupon/update",
    // 暂停活动
    ACTIVITY_COUPON_PAUSE: "/api/activity/coupon/pause",
    // 启用活动
    ACTIVITY_COUPON_ACTIVE: "/api/activity/coupon/active",
    // 删除活动
    ACTIVITY_COUPON_DELETE: "/api/activity/coupon/delete",
    // 提前结束活动
    ACTIVITY_COUPON_TERMINAL: "/api/activity/coupon/terminal",
    // 获取优惠劵
    ACTIVITY_COUPON_GET: "/api/activity/coupon/get",
    // 查询店铺满赠优惠劵
    ACTIVITY_COUPON_LIST_BY_STORENO: "/api/activity/coupon/listByStoreNo",
    // 优惠券统计查询列表
    GET_COUPON_STATISTICS: "/api/activity/coupon/couponStatistics",
    // 优惠券统计列表导出接口
    DOWNLOAD_COUPON_LIST: "/api/coupon/downloadCouponList",
    //设置优惠券时选择商品的搜索
    ACTIVITY_COUPON_PROD_LIST: "/api/activity/coupon/merchandise",
    //设置优惠券时选择店铺的搜索
    ACTIVITY_COUPON_STORE_LIST: "/api/activity/coupon/store"
};

// 套餐活动
const ACTIVITY_GROUP = {
    // 套餐活动条件查询
    ACTIVITY_GROUP_QUERY: "/api/activity/group/query",
    // 根据ID查询
    ACTIVITY_GROUP_GET: "/api/activity/group/get",
    // 新增套餐
    ACTIVITY_GROUP_INSERT: "/api/activity/group/insert",
    // 编辑套餐
    ACTIVITY_GROUP_UPDATE: "/api/activity/group/update",
    // 修改套餐状态
    ACTIVITY_GROUP_STATUS: "/api/activity/group/status",
    // xxx
    ACTIVITY_GROUP_: ""
};

// 满赠促销
const ACTIVITY_REWARD = {
    // 满赠活动条件查询
    ACTIVITY_REWARD_QUERY: "/api/activity/reward/query",
    // 根据ID查询
    ACTIVITY_REWARD_GET: "/api/activity/reward/get",
    // 新增满赠
    ACTIVITY_REWARD_INSERT: "/api/activity/reward/insert",
    // 编辑满赠
    ACTIVITY_REWARD_UPDATE: "/api/activity/reward/update",
    // 修改满赠活动状态
    ACTIVITY_REWARD_STATUS: "/api/activity/reward/status",
    // xxx
    ACTIVITY_REWARD_: ""
};

// 秒杀活动
const ACTIVITY_SECKILL = {
    // 秒杀活动条件查询
    ACTIVITY_SECKILL_QUERY: "/api/activity/seckill/query",
    // 根据ID查询
    ACTIVITY_SECKILL_GET: "/api/activity/seckill/get",
    // 新增满赠
    ACTIVITY_SECKILL_INSERT: "/api/activity/seckill/insert",
    // 编辑满赠
    ACTIVITY_SECKILL_UPDATE: "/api/activity/seckill/update",
    // 修改满赠活动状态
    ACTIVITY_SECKILL_STATUS: "/api/activity/seckill/status"
};

// 跨店满减
const REBATE_CROSS = {
    // 查询
    REBATE_CROSS_QUERY: "/api/activity/rebate/queryCrossActivityForPlatform",
    // 新增
    REBATE_CROSS_ADD: "/api/activity/rebate/insertCrossActivity",
    // 暂停跨店满减
    REBATE_CROSS_PAUSE: "/api/activity/rebate/pauseRebateCross",
    // 启用跨店满减
    REBATE_CROSS_ACTIVE: "/api/activity/rebate/activeRebateCross",
    // 删除活动
    REBATE_CROSS_DELETE: "/api/activity/rebate/deleteActivity",
    // 客户查询，跨店满减列表(正在报名中的数据)
    REBATE_CROSS_QUERY_CUST: "/api/activity/rebate/queryCrossActivityForCust",
    // 提交报名
    REBATE_CROSS_submitCrossApplication:
        "/api/activity/rebate/submitCrossApplication",
    // 用于查询跨平台满减活动的详情
    REBATE_CROSS_getCrossActivityById:
        "/api/activity/rebate/getCrossActivityById",
    // 编辑跨店铺满减活动
    REBATE_CROSS_updateCrossActivity:
        "/api/activity/rebate/updateCrossActivity",
    // 平台或站点，查询待审核的报名列表
    REBATE_CROSS_queryCrossApplicationForAudit:
        "/api/activity/rebate/queryCrossApplicationForAudit",
    // 获取跨店满减详情(客户/驳回原因字段)
    REBATE_CROSS_getCrossApplicationResult:
        "/api/activity/rebate/getCrossApplicationResult",
    // 审核通过
    REBATE_CROSS_passCrossApplication:
        "/api/activity/rebate/passCrossApplication",
    // 审核不通过
    REBATE_CROSS_rejectCrossApplication:
        "/api/activity/rebate/rejectCrossApplication"
};

// 邀请有礼
const INVITE_GIFT = {
    // 获取邀请有礼活动列表
    GET_INVITE_LIST: "/api/activity/invite/query",
    // 获取可选优惠券列表
    GET_COUPON_INVITELIST: "/api/activity/coupon/inviteList",
    // 选择领券活动分页列表
    GET_COUPON_RECEIVELIST: "/api/activity/coupon/receiveList",
    // 邀请活动新增
    INVITE_INSERT: "/api/activity/invite/insert",
    // 邀请有礼统计数据列表
    GET_INVITE_STATS_LIST: "/api/invite/summary/list",
    // 邀请有礼统计数据导出
    EXPORT_INVITE_STATS_LIST: "/api/invite/summary/export",
    // 获取邀请有礼统计数据客户明细
    GET_INVITE_STATS_CUST_DETAIL: "/api/invite/summary/custDetailList",
    // 邀请活动启用
    INVITE_ACTIVE: "/api/activity/invite/active",
    // 邀请活动提前结束
    INVITE_TERMINAL: "/api/activity/invite/terminal",
    // 邀请活动暂停
    INVITE_PAUSE: "/api/activity/invite/pause",
    // 邀请活动查看
    INVITE_GET: "/api/activity/invite/get",
    // 邀请活动更新
    INVITE_UPDATE: "/api/activity/invite/update"
};

// 超值换购
const ACTIVITY_PURCHASE = {
    ACTIVITY_PURCHASE_LIST: '/api/activity/buyGive/query',
    ACTIVITY_PURCHASE_UPDATE: '/api/activity/buyGive/save',
    ACTIVITY_PURCHASE_DETAIL: '/api/activity/activityBuyGive/getByActivityId',
    ACTIVITY_PURCHASE_DELETE: '/api/activity/deleteActivity',
    ACTIVITY_PURCHASE_END: '/api/activity/terminal'
}

// 批量售卖申请
const SALES_APPLY = {
    // 各个状态统计
    SALES_APPLY_STATS: "/api/sales_apply/stats",
    // 数据列表
    SALES_APPLY_LIST: "/api/sales_apply/list",
    // 手动选择数据列表
    SALES_APPLY_SELECT_GOODS_LIST: "/api/select_goods/list",
    // 手动选择
    SALES_APPLY_SELECT_GOODS_SET: "/api/select_goods/set",
    // 提交批量售卖申请
    SALES_APPLY_BATCH_SUBMIT: "/api/sales_apply/batch_submit",
    // 查询Goods_Ds数据
    SALES_APPLY_GOODS_DS: "/api/sales_apply/goods_ds"
};

// 首页配置
const HOME_CONFIG = {
    // 首页配置列表
    HOME_CONF_LIST: "/api/page/getPaltFormList",
    // 更新首页配置楼层排序
    HOME_CONF_EDIT_ORDER: "/api/page/editFloorOrder",
    // 首页配置楼层删除
    HOME_CONF_DELETE_FLOOR: "/api/page/deletePageListModule",
    // 获取轮播图列表
    HOME_CONF_SLIDER_LIST: "/api/page/getRotationChartList",
    // 保存轮播图配置
    HOME_CONF_SLIDER_SAVE: "/api/page/addRotationChart",
    // 获取导航列表
    GET_NAVIGATION_LIST: "/api/page/getNavigationList",
    // 保存导航栏接口
    SAVE_NAVIGATION_LIST: "/api/page/saveNavigationList",
    // 商品楼层列表
    IMG_FLOOR_LIST: "/api/page/getImgFloorList",
    // 保存商品楼层
    IMG_FLOOR_SAVE: "/api/page/addImgFloor",
    // 获取顶部广告
    GET_TOP_AD: "/api/page/getTopAddetail",
    // 保存顶部广告
    SAVE_TOP_AD: "/api/page/editOrSaveTopAd",
    // 获取翅膀
    GET_WING_DETAIL: "/api/page/getWingDetail",
    // 保存翅膀
    SAVE_WING_LIST: "/api/page/saveWingList",
    // 商品楼层详情
    GOODS_FLOOR_DETAIL: "/api/page/getGoodsFloorDetail",
    // 保存商品楼层配置
    GOODS_FLOOR_SAVE: "/api/page/saveGoodsFloor",
    // 商品楼层查询可添加的商品
    GOODS_FLOOR_SEARCH_GOODS: "/api/page/getFloorMerchandise",
    // 获取热词列表
    GET_HOTWORD_LIST: "/api/page/getHotWordList",
    // 保存热词
    SAVE_HOTWORD_LIST: "/api/page/saveHotWordList",
    // 小程序banner配置
    GET_WXPAGESLIDER_LIST: "/api/page/wxPageSlider",
    // 获取内部链接下拉选项
    QUERY_DICT_LIST: "/api/dict/queryDictList"
};

// 自定义专题页配置
const THEME_CONFIG = {
    // 获取专题页分页列表
    GET_SPECIALPAGE_LIST: "/api/page/getSpecialPageList",
    // 获取自定义专题页详情
    GET_SPECIALPAGE_DETAIL: "/api/page/getSpecialPageDetail",
    // 保存/编辑自定义专题页
    SAVE_SPECIAL_PAGE: "/api/page/saveSpecialPage",
    // 套餐分页列表
    GET_COMB_PAGE: "/api/activity/group/pageList",
    // 套餐分页列表
    DELETE_SPECIAL_PAGE: "/api/page/deleteSpecialPage"
};

// 类目标品
const CATEGORY_GOODS = {
    // 查询类目标品分页列表
    GET_CATEGORY_GOODS_PAGE_LIST: "/api/goods/getCategoryGoodsPageList",
    // 清空标品类目
    CLEAR_GOODS_CATEGORY: "/api/goods/clearGoodsCategory",
    // 绑定标品类目
    BIND_GOODS_CATEGORY: "/api/goods/bindGoodsCategory",
    // 快速查询导航分类类目
    GET_CATEGORY_LIST: "/api/navigationCategory/getCategoryList",
    // 获取逐级导航分类列表
    GET_LEVEL_CATEGORY_LIST: "/api/navigationCategory/getLevelCategoryList",
    // 查询导航分类配置列表
    GET_CONFIG_CATEGORY_LIST: "/api/navigationCategory/getConfigCategoryList",
    // 获取逐级导航分类列表
    GET_MYGOOD_LEVEL_CATEGORY_LIST:
        "/api/navigationCategory/queryLevelCategoryList",
    // 导航分类配置保存
    CONFIG_CATEGORY: "/api/navigationCategory/configCategory"
};

const FLOW_DIRECTION = {
    GET_FLOW_LIST: "/api/erpBill/pageErpBillList.json"
};

const FROMT_REGIEST = {
    SEND_SMS_CODE: "/sms/sendMessageWithValidCode",
    CHECK_VCODE: "/checkVcode",
    CHECK_PHONE: "/api/check/phone.json",
    STORE_REGISTER: "/api/store/register.json",
    BUYER_REGISTER: "/api/buyer/register.json",
    GET_DICT: "/api/dict/getDict",
    GET_CELL_DATA: "/api/community/cellTree",
    GET_AREA_DATA: "/api/store/siteAreaData.json",
    GET_AUTH_INFO: "/api/store/current.json",
    SAVE_BASE_INFO: "/api/save/next.json",
    UPLOAD_LIC_IMG: "/api/store/certificate/uploadImg.json",
    GET_PROD_SCOPED_LIST: "/api/prodscopenoList",
    GET_MUST_LIC: "/api/storeCer/mustLic.json",
    GET_SAVE_LIC: '/api/storeSave/lic.json',
    GET_SCOPE_LIC: "/api/storeCer/lic.json",
    SAVE_LIC_INFO: "/api/save/quaInfo.json",
    SUBMIT_AUDIT: "/api/submit.json",
    // GET_AUTH_STATUS: "/store/qualificationStep1.json",
    GET_AUTH_RESULT: "/api/store/approveInfo.json",
    GET_LOGIN_STATUS: "/user/loginStatus.json",
    LOGIN: "/user/login",
    GET_BUYER_BASIC: '/api/buyer/goAuth.json',
    GET_DICT: '/api/dict/getDict',
    POST_BUYER_BASIC: '/api/buyer/authStep1.json',
    GET_BUYER_MUST_LIC: '/api/buyer/getMustLicence.json',
    GET_BUYER_SCOPE_LIC: '/api/buyerCer/lic.json',
    GET_BUYER_SAVE_LIC: '/api/buyerSave/lic.json',
    SAVE_BUYER_LIC: '/api/buyer/saveQuaInfo.json',
    SUBMIT_BUYER_AUDIT: '/api/buyer/submitAuth.json'
};

function formatUrl (obj) {
    Object.keys(obj).forEach(key => {
        obj[key] = `https://t-wyc.yun-sk.com${obj[key]}`
    })
}

let allObj = {
    ...FROMT_REGIEST,
    ...COMMON,
    ...SITE_MGR,
    ...GOODS_MGR,
    ...SYS_ROLE,
    ...ACCOUNT_MGR,
    ...MENU_MGR,
    ...SHOP_MENU_MGR,
    ...SYS_NOTICE,
    ...ORDER_MGR,
    ...UEDITORS,
    ...CUST_MGR,
    ...SHOP_MGR,
    ...PAYMENT_CENTER,
    ...SECOND_KILL,
    ...AGREED_AREAS,
    ...LABLE,
    ...ACTIVITY_REBATE,
    ...ACTIVITY_COUPON,
    ...ACTIVITY_GROUP,
    ...ACTIVITY_REWARD,
    ...ACTIVITY_SECKILL,
    ...REBATE_CROSS,
    ...SALES_APPLY,
    ...HOME_CONFIG,
    ...THEME_CONFIG,
    ...CATEGORY_GOODS,
    ...INVITE_GIFT,
    ...FLOW_DIRECTION,
    ...ACTIVITY_PURCHASE
};

// formatUrl(allObj)
export default allObj



// WEBPACK FOOTER //
// ./src/apis/index.js